import React from "react";
import { Badge } from "@chakra-ui/react";


const STATUS_META = {
  suggested: { colorScheme: "blue", label: "Sugerido" },
  pending_approval: { colorScheme: "orange", label: "Pendiente de aprobación" },
  approved: { colorScheme: "cyan", label: "Aprobado" },
  executed: { colorScheme: "green", label: "Ejecutado" },
  rejected: { colorScheme: "red", label: "Rechazado" },
  cancelled: { colorScheme: "gray", label: "Descartado" },
  open: { colorScheme: "red", label: "Abierto" },
  acknowledged: { colorScheme: "orange", label: "Visto" },
  resolved: { colorScheme: "green", label: "Resuelto" },
  dismissed: { colorScheme: "gray", label: "Descartado" },
  ready: { colorScheme: "green", label: "Listo" },
  blocked: { colorScheme: "red", label: "Bloqueado" },
  reviewed: { colorScheme: "purple", label: "Revisado" },
  draft: { colorScheme: "gray", label: "Borrador" },
  queued: { colorScheme: "orange", label: "Pendiente" },
  sent: { colorScheme: "blue", label: "Enviado" },
  delivered: { colorScheme: "green", label: "Entregado" },
  read: { colorScheme: "purple", label: "Leído" },
  failed: { colorScheme: "red", label: "Falló" },
  // Semáforo de inventario (inventario/semaforo.py).
  critico: { colorScheme: "red", label: "Crítico" },
  alerta: { colorScheme: "yellow", label: "Alerta" },
  normal: { colorScheme: "green", label: "Normal" },
  excluido: { colorScheme: "gray", label: "Sin seguimiento" },
};


const WamStatusBadge = ({ status = "", label = "", colorScheme, ...rest }) => {
  const normalizedStatus = String(status || "").toLowerCase();
  const meta = STATUS_META[normalizedStatus] || {};
  const resolvedLabel = label || meta.label || status || "Estado";
  const resolvedColorScheme = colorScheme || meta.colorScheme || "gray";

  return (
    <Badge
      variant="subtle"
      colorScheme={resolvedColorScheme}
      borderRadius="full"
      px={3}
      py={1}
      fontSize="0.72rem"
      {...rest}
    >
      {resolvedLabel}
    </Badge>
  );
};


export default WamStatusBadge;
